import { render, staticRenderFns } from "./EditRewardApproval.vue?vue&type=template&id=a65cfb8a&scoped=true"
import script from "./EditRewardApproval.vue?vue&type=script&lang=js"
export * from "./EditRewardApproval.vue?vue&type=script&lang=js"
import style0 from "./EditRewardApproval.vue?vue&type=style&index=0&id=a65cfb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65cfb8a",
  null
  
)

export default component.exports